import type { Observable, OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

import type { Type } from '@angular/core';

export function mapTo<T, U>(constructor: Type<T>): OperatorFunction<U, T> {
	return (source$: Observable<U>) => source$.pipe(map(sourceValue => new constructor(sourceValue)));
}
